import { PintInput } from "@shared/common/components/PintInput";
import { DATETIME_FORMAT_NO_TIME, getDatesFromInterval } from "@shared/common/utils/luxonHelpers";
import { inputValueChangeHandler } from "@shared/lion";
import { DateTime, Interval } from "luxon";
import { useMemo, useState } from "react";

interface TimeSelectionProps {
  readonly currentTime: DateTime<true>;
  readonly allowedTimeInterval: Interval<true>;
  readonly onTimeChange: (datetime?: DateTime<true>) => void;
  readonly dateLabel?: string;
  readonly timeLabel?: string;
}

export function TimeSelection({
  currentTime,
  allowedTimeInterval,
  onTimeChange,
  dateLabel = "Datum",
  timeLabel = "Tijd",
}: TimeSelectionProps) {
  const [selectedDate, setSelectedDate] = useState<DateTime<true>>(currentTime);

  const datesInInterval = useMemo<DateTime<true>[]>(
    () => getDatesFromInterval(allowedTimeInterval),
    [allowedTimeInterval],
  );

  const handleDateChange = inputValueChangeHandler<string>((updatedValue) => {
    const parsedDate = DateTime.fromISO(updatedValue);
    if (parsedDate.isValid) {
      setSelectedDate(parsedDate);
    }
  });

  return (
    <>
      <tractie-select
        label={dateLabel}
        name={dateLabel}
        onmodel-value-changed={handleDateChange}
        modelValue={selectedDate.toISODate()}
      >
        <select slot="input">
          {datesInInterval.map((day) => (
            <option key={day.toISODate()} value={day.toISODate()}>
              {day.toFormat(DATETIME_FORMAT_NO_TIME)}
            </option>
          ))}
        </select>
      </tractie-select>
      <PintInput
        label={timeLabel}
        initialValue={currentTime}
        date={selectedDate}
        window={allowedTimeInterval}
        onValueChange={onTimeChange}
      />
    </>
  );
}
